import { Typography } from "@material-ui/core";
import React from "react";

const Home = () => <Typography>Welcome to the Real World</Typography>;
export default Home;
